export const environment = {
  production: false,
  // serverIP: 'https://munsalik-api.lfdanalytics.com/',
  serverIP: 'https://screening-api.lfdanalytics.com/',
};